<template>
  <section>
    <b-modal
      ref='modalInstructionalVideos'
      id='modalInstructionalVideos'
      hide-footer
      hide-header
      header-bg-variant='info'
      header-text-variant='light'
      size='xl'
      scrollable
      @show='showModal()'
      @hide="$emit('update')"
    >
      <b-overlay
        :show="loadingOverlay"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
        class="d-inline-block w-100"
        style="min-height: 100px"
      >
        <section class='modal-font-family modal-instructional-videos'>
          <section class='d-flex justify-content-between align-items-start w-100 header '>
            <section>
              <p v-if="instructionalVideoId" class='title mb-0'>Editar vídeo de tutorial</p>
              <p v-else class='title mb-0'>Adicionar vídeo de tutorial</p>
              <span class="sub-title">Preencha os campos abaixo para adicionar o vídeo de tutorial</span>
            </section>
            <section>
              <b-icon
                @click='closeModalInstructionalVideos()'
                class='cursor-pointer'
                font-scale='2.5'
                icon='x'
                color='#022245'
              >
              </b-icon>
            </section>
          </section>

          <section>
            <hr />
          </section>

          <section>
            <section class="mb-2">
              <label for="triggerTags">Tags de gatilho</label>
              <b-tooltip target="tagExport" triggers="hover" placement="top">
                Exportar tag
              </b-tooltip>
              <b-icon v-if="instructionalVideo.triggerTag" id='tagExport' class="cursor-pointer ml-2" @click="exportToExcel()" icon="file-excel-fill"></b-icon>
            </section>
            <b-form-select
              id="triggerTags"
              v-model="instructionalVideo.triggerTag"
              :options='tagsInstructionalVideos'
              value-field='tag'
              text-field='tagDescription'
            >
            </b-form-select>
          </section>

          <section class="mt-4">
            <label for="videoLink">Link do vídeo</label>
            <b-form-input
              v-model="instructionalVideo.videoLink"
              placeholder="Digite o link do vídeo"
            >
            </b-form-input>
          </section>

          <section class="mt-4">
            <label class="mb-1" for="aba">Abas de funcionalidade</label>
            <section
              style='display: grid;  grid-template-columns: repeat(auto-fill, minmax(33%, auto));'
            >
              <b-form-checkbox-group
                v-model='instructionalVideo.tabs'
                v-for='(tab, i) in tabs'
                :key='i'
              >
                <b-form-checkbox
                  class=''
                  :value='tab.value'
                  @change="checkSelectedTab(tab.value)"
                >
                  <span class=' mt-2'>{{ tab.tab }}</span>
                </b-form-checkbox>
              </b-form-checkbox-group>
            </section>
            <hr/>
          </section>


          <section class="mt-4">
            <label for="title">Título do vídeo tutorial</label>
            <b-form-textarea
              id="title"
              v-model="instructionalVideo.title"
              placeholder="Digite a descrição de mensagem"
            >
            </b-form-textarea>
          </section>

          <section class="mt-4">
            <label for="description">Descrição do vídeo tutorial</label>
            <b-form-textarea
              id="description"
              v-model="instructionalVideo.description"
              placeholder="Digite a descrição do vídeo tutorial"
            >
            </b-form-textarea>
          </section>

          <section class="mt-4">
            <b-alert
              show
              variant='danger'
              :class='{ hidden: !errors }'
            >
              {{ errors }}
            </b-alert>
          </section>

          <section class="d-flex justify-content-between mt-4">
            <base-button @click="closeModalInstructionalVideos()" class="w-50 mr-3 btn-cancel">
              <span>Cancelar</span>
            </base-button>

            <b-overlay
              :show="loading"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block w-50"
            >
              <base-button
                class="w-100 btn-add d-flex align-items-center justify-content-center"
                @click="submit()"
              >
                <span v-if="instructionalVideoId" class="mr-2">Editar vídeo tutorial</span>
                <span  v-else class="mr-2">Adicionar vídeo tutorial</span>
              </base-button>
            </b-overlay>
          </section>
        </section>

        <template v-slot:overlay>
          <div class="text-center loading-spinner">
            <b-spinner
              style="width: 3rem; height: 3rem"
              variant="primary"
              label="Large Spinner"
            ></b-spinner>
            <h5 class="text-primary">Buscando...</h5>
          </div>
        </template>
      </b-overlay>
    </b-modal>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import axios from 'axios'
import XLSX from 'xlsx'

export default {
  name: 'ModalInstructionalVideos',
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      checked: false,
      loadingOverlay: false,
      loading: false,
      tagsInstructionalVideos: [],
      instructionalVideo: {
        triggerTag: null,
        videoLink: null,
        tabs: [],
        description: null,
        title: null,
      },
      tabs: [
        {
          value: null,
          tab: 'Não selecionar nenhuma aba'
        },
        {
          value: 'Summary',
          tab: 'Seleção de agentes'
        },
        {
          value: 'Insalubrity',
          tab: 'Laudo de Insalubridade'
        },
        {
          value: 'Gro',
          tab: 'GRO'
        },
        {
          value: 'Ltcat',
          tab: 'LTCAT'
        },
        {
          value: 'PreventionistLimits',
          tab: 'Limites Prevencionistas'
        },
        {
          value: 'QuantitativeAssessment',
          tab: 'Avaliação Quantitativa'
        },
        {
          value: 'Pcmso',
          tab: 'PCMSO'
        }
      ],
    }
  },
  props: {
    instructionalVideoId: { type: String, required: false, default: null },
  },
  computed: {
    errors() {
      return this.$store.getters['access/error']
    }
  },
  validations() {
    return {
      instructionalVideo: {
        triggerTag: { },
        videoLink: { },
        tabs: { },
        description: { required },
        title: { }
      }
    }
  },
  methods: {
    ...mapActions('tags', {
      handleTagsInstructionalVideos: 'handleTagsInstructionalVideos'
    }),
    ...mapActions('instructionalVideo', {
      handleCreate: 'handleCreate',
      handleGet: 'handleGet',
      handleUpdate: 'handleUpdate',
    }),

    exportToExcel() {
      const data = this.tagsInstructionalVideos.filter(x => x.tag === this.instructionalVideo.triggerTag).map((x) => {
        return{
          Tag: x.tag,
          ['Descrição']: x.description,
          ['Gatilho/Tarefa/Rotina']: x['Gatilho/Tarefa/Rotina']
        }
      })

      const worksheet = XLSX.utils.json_to_sheet(data)
      const workbook = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Planilha1')
      XLSX.writeFile(workbook, `${this.instructionalVideo.triggerTag}.xlsx`)
    },

    async showModal() {
      try {
        await this.$store.dispatch('access/updateError', ``)
        this.instructionalVideo = {
          triggerTag: null,
          videoLink: null,
          tabs: [],
          description: null,
          title: null,
        }
        const { items } = await this.handleTagsInstructionalVideos()

        this.tagsInstructionalVideos = items.map((x) => {
          return {
            ...x,
            tagDescription: `${x.description}${x.tag ? ` (${x.tag})` : ''}`
          }
        })

        if(this.instructionalVideoId){
          this.loadingOverlay = true
          const { data: dataResponse } = await this.handleGet(this.instructionalVideoId)
          const { data } = dataResponse
          this.instructionalVideo = data
          this.loadingOverlay = false
        }
      } catch (e) {

      }
    },

    closeModalInstructionalVideos() {
      this.$bvModal.hide('modalInstructionalVideos')
    },
    videoLinkIsValid() {
      const isLink = this.instructionalVideo.videoLink.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)

      if (isLink === null) {
        return false
      }
      return true
    },
    checkSelectedTab(tab) {
      if(tab){
        setTimeout(() => {
          this.instructionalVideo.tabs = this.instructionalVideo.tabs.filter(x => x)
        }, 100)
      } else {
        setTimeout(() => {
          this.instructionalVideo.tabs = [null]
        }, 100)
      }
    },
    async submit() {
      try {
        const validate = await this.v$.$validate()
        if (!validate) {
          await this.$store.dispatch('access/updateError', `Preencha todos os campos corretamente`)
          this.loading = false
          return
        }
        this.loading = true
        if(this.instructionalVideo.videoLink) {
          if (!this.videoLinkIsValid()) {
            await this.$store.dispatch('access/updateError', `Por favor, insira um link do vídeo válido!`)
            return
          }

          try {
            const linkYoutube = `https://www.youtube.com/oembed?url=${this.instructionalVideo.videoLink}&format=json`
            const {
              data: dataInstructionalVideo,
              status: statusInstructionalVideo
            } = await axios.get(linkYoutube.replace('v%', 'v='))

            if (statusInstructionalVideo === 200 && dataInstructionalVideo && dataInstructionalVideo.title) {
              this.instructionalVideo.title = dataInstructionalVideo.title
            } else {
              await this.$store.dispatch('access/updateError', `Vídeo não encontrado!`)
              this.loading = false
              return
            }
          } catch (e) {
            await this.$store.dispatch('access/updateError', `Vídeo não encontrado!`)
            this.loading = false
            return
          }
        } else {
          this.instructionalVideo.videoLink = null
        }

        let response = {}
        if(this.instructionalVideoId){
          response = await this.handleUpdate(this.instructionalVideo)
        } else {
          response = await this.handleCreate(this.instructionalVideo)
        }
        const { data, status, errors } = response
        let message = errors
        let variant = 'danger'

        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })

        this.closeModalInstructionalVideos()
        this.loading = false
        this.$emit('load')
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-instructional-videos {
  .header {
    .title {
      font-weight: 700;
      font-size: 18px;
      color: var(--navy-blue);
    }

    .sub-title {
      font-weight: 400;
      font-size: 15px;
      color: #808080;
    }

    .btn-add-tutorial {
      font-weight: 400;
      font-size: 15px;
      border: 1px solid #AEBBCD;
      border-radius: 6px;
      color: #6D7989;
      background: #FFFFFF;
    }
  }

  label {
    font-weight: 700;
    font-size: 16px;
    color: #262626;
    margin-bottom: 0;
  }

  .btn-cancel {
    background: transparent !important;
    border-radius: 6.25px !important;
    border: 1px solid var(--navy-blue) !important;

    span {
      color: var(--navy-blue);
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
    }
  }

  .btn-add {
    background: var(--navy-blue) !important;
    border-radius: 6.25px !important;
    border: 1px solid var(--navy-blue) !important;

    span {
      color: #ffffff;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
    }
  }
}

</style>